import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Card, CardMedia, Grid, useMediaQuery } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import PostAddIcon from '@mui/icons-material/PostAdd';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import IconButton from '@mui/material/IconButton';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { FreeMode, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/free-mode";
import SwiperCore, { Navigation } from 'swiper';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.News.fields';
SwiperCore.use([Navigation]);

const News = () => {

    const Layout1600 = useMediaQuery('(min-width:1600px)');
    const Layout1290 = useMediaQuery('(min-width:1290px)');
    const Layout660 = useMediaQuery('(min-width:660px)');


    const navigationPrevRef = React.useRef(null)
      const navigationNextRef = React.useRef(null)


    const [lstData, setlstData] = useState([] as any);
    const [LinkAll, setLinkAll] = useState(null);

    useEffect(() => {
        GetNews();
    }, [])

    const GetNews = () => {
        AxiosGet(`News/GetNews`, { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setlstData(res.result.data || [])
                setLinkAll(res.result.sLinkGBUNews)
            })
        }, null, null)
    }

    return (

        <>
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ padding: '3% 8%' }}>
                <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item>
                            <Typography
                                sx={{
                                    color: "#000080",
                                    fontWeight: "500",
                                    fontSize: Layout1290 ? "4.5em" : Layout660 ? '3.8em' : '3em',
                                    lineHeight: "1.0",
                                    marginLeft: "25px"
                                }}>
                                GBU
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#000080",
                                    fontWeight: "100",
                                    fontSize: Layout1290 ? "4.5em" : Layout660 ? '3.8em' : '3em',
                                    lineHeight: "0.5",
                                    marginLeft: "25px"
                                }}>
                                NEWS
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" className="btn-allnews" style={{ borderRadius: "20px" }} endIcon={<ArrowForwardIcon />}
                            onClick={() => {window.open(LinkAll)}}
                            >
                             {i18n(`${i18nField}.sViewAll`)}
                            </Button>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item xs={12} style={{marginTop: Layout660 ? '3em' : '1em' }}>
                    <Swiper
                        
                        slidesPerView={Layout1600 ? 4 : Layout1290 ? 3 : Layout660 ? 2 : 1}
                        spaceBetween={0}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                          }}
                         
                        modules={[FreeMode]}
                        className="mySwiper"
                        
                    >

                        {lstData.length > 0 && lstData.map((item, indx) => {
                            return (

                                <SwiperSlide key={item.sNewsID} style={{ backgroundColor: 'transparent' }}>
                                    <Card
                                        style={{ padding: '12px' }}
                                        sx={{
                                            maxWidth: 600,
                                            width: '100%',
                                            p: 1.25,
                                            border: "none",
                                            boxShadow: "-3px 2px 30px rgb(0 0 0 / 10%)",
                                            background: "transparent",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={item.sFileLink}
                                            alt=""
                                            className='news-slide-img'
                                            // sx={{
                                            //     height: "250px",
                                            //     width: "250px",
                                            //     borderRadius: "50%",
                                            //     margin: 'auto',
                                            //     boxShadow: "0 12px 34px rgba(0, 0, 0, 0.5)",
                                            // }}
                                        />
                                        <CardContent sx={{ maxHeight: 100, height: 100, boxSizing: "content-box",textAlign:'left' }}>
                                            <Typography variant="body1" className='news-title' style={{ color: '#202178', fontSize: Layout660 ? '18px' : '14px'}}>
                                                {item.sNewsTitle}
                                            </Typography>
                                            <Grid item xs={12}>
                                                <Divider />
                                            </Grid>
                                            <Typography variant="body2" className='news-detail' style={{ color: '#202178', fontSize: Layout660 ? '18px !important' : '14px !important'}}>
                                                {item.sNewsDes}
                                            </Typography>
                                        </CardContent>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                        <CardActions style={{ padding: "9px 9px 0px 9px" }}>
                                            <div className="btn-news" onClick={() => { window.open(item.sLinkTo) }}>
                                                <PostAddIcon sx={{ fontSize: Layout660 ? "1rem" : "0.8rem", color: "#fff" }} /> 
                                                {currentLanguage() == "th" ? "อ่านต่อ" : "Read On."}
                                            </div>
                                        </CardActions>
                                    </Card>

                                </SwiperSlide>

                            )
                        })}

                    </Swiper>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                        <Grid item >
                            <IconButton ref={navigationPrevRef} aria-label="ArrowBack" size={ Layout660 ? "large" : "small"} style={{ backgroundColor: "#242377" }} >
                                <ArrowBackIosRoundedIcon style={{ color: "#ffffff" }} />
                            </IconButton>
                        </Grid>
                        <Grid item >
                            <IconButton ref={navigationNextRef} aria-label="ArrowForward" size={ Layout660 ? "large" : "small"} style={{ backgroundColor: "#0477e1" }}>
                                <ArrowForwardIosRoundedIcon style={{ color: "#ffffff" }} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>

    )
}

export default News